import './App.scss';
import {Component} from 'react';
import Editor from './components/Editor.js';
import CheckList from './components/CheckList.js';
import Settings from './components/Settings';
import InfoBar from './components/InfoBar';
import LocalStorage from './lib/LocalStorage.js';
import Markup from './lib/Markup.js';

class App extends Component {
	constructor(props) {
		super(props);
		let content = LocalStorage.getItem('editor-content') || '';
		let aiModel = this.getSetting('aiModel');
		if (aiModel) {
			if (aiModel === 'gpt-4-turbo') {
				aiModel = 'gpt-4o';
			}
			if (aiModel.includes('3.5')) {
				aiModel = 'gpt-4o-mini';
			}
		}
		this.state = {
			loggedIn: false,
			content: Markup.removeEmptyLines(content).replaceAll('&nbsp;', ' '),
			siteUrl: '',
			settingsShown: false,
			settings: {
				maxWordsPerSentence: parseInt(this.getSetting('maxWordsPerSentence')) || 20,
				maxSentencesPerParagraph: parseInt(this.getSetting('maxSentencesPerParagraph')) || 5,
				maxWordsPerParagraph: parseInt(this.getSetting('maxWordsPerParagraph')) || 100,
				maxParagraphsPerHeading: parseInt(this.getSetting('maxParagraphsPerHeading')) || 3,
				maxWordsInIntro: parseInt(this.getSetting('maxWordsInIntro')) || 30,
				minKeywordDensity: this.getSetting('minKeywordDensity') || '',
				maxKeywordDensity: this.getSetting('maxKeywordDensity') || '',
				minContentLength: this.getSetting('minContentLength') || '',
				maxContentLength: this.getSetting('maxContentLength') || '',
				disallowedWords: this.getSetting('disallowedWords') || '',
				language: this.getSetting('language') || 'en',
				keywordSrc: this.getSetting('keywordSrc') || 'tfidf',
				aiModel: aiModel  || 'gpt-4o',
			},
			user: {},
			limitUsage: {
				daily: {
					'article-generator': 0,
				},
				monthly: {
					'article-generator': 0,
				}
			},
			limits: {
				daily: {
					'article-generator': 0,
				},
				monthly: {
					'article-generator': 0,
				}
			},
			permissions: [],
			score: 0,

		};
		this.saveContent = this.saveContent.bind(this);
		this.saveUrl = this.saveUrl.bind(this);
		this.toggleSettings = this.toggleSettings.bind(this);
		this.handleSettingsChange = this.handleSettingsChange.bind(this);
		this.saveScore = this.saveScore.bind(this);
		this.updateLimitUsage = this.updateLimitUsage.bind(this);
	}

	saveContent(content) {
		if (content !== this.state.content) {
			if (!Markup.stripTags(content).trim()) {
				content = '';
			}
			this.setState({content: content});
			content = Markup.removeEmptyLines(content).replaceAll('&nbsp;', ' ');
			if (content) {
				LocalStorage.setItem('editor-content', content);
			} else {
				LocalStorage.removeItem('editor-content');
			}
		}
	}

	saveScore(value) {
		let text = Markup.stripTags(this.state.content);
		this.setState({score: text ? value : 0});
	}

	async componentDidMount() {
		const urlParams = new URLSearchParams(window.location.search);
		const forceFree = urlParams.get('free') || false;
		const data = new FormData();
		if (forceFree) {
			data.append('free', true);
		}

		await fetch('ajax/session.php', {
			method: 'POST',
			body: data,
		})
		.then((response) => {
			if (response.status < 400) {
				return response.json();
			} else {
				console.error('Could not fetch session data');
				return {
					loggedIn: false,
				}
			}
		})
		.then((data) => {
			let dailyLimit = 0;
			let monthlyLimit = 0;
			if (data.planData && data.planData.limits) {
				if (data.planData.limits.daily && 'article-generator' in data.planData.limits.daily) {
					dailyLimit = data.planData.limits.daily['article-generator'];
				}

				if (data.planData.limits.monthly && 'article-generator' in data.planData.limits.monthly) {
					monthlyLimit = data.planData.limits.monthly['article-generator'];
				}
			}

			let newState = {
				loggedIn: !!data.loggedIn,
				user: data.user,
				limits: {
					daily: {
						'article-generator': dailyLimit,
					},
					monthly: {
						'article-generator': monthlyLimit,
					}
				},
				limitUsage: {
					daily: {
						'article-generator': data.limitUsage ? data.limitUsage.daily.articleGenerator || 0 : 0,
					},
					monthly: {
						'article-generator': data.limitUsage ? data.limitUsage.monthly.articleGenerator || 0 : 0,
					}
				}
			}

			if (data.planData.permissions) {
				newState.permissions = data.planData.permissions.filter((perm) => perm.includes('content-'));
			}

			this.setState(newState);
		})
		.catch((error) => {
			console.error(error);
			this.setState({
				loggedIn: false
			});
		});
	}

	saveUrl(url) {
		this.setState({siteUrl: url});
	}

	toggleSettings() {
		let value = !this.state.settingsShown;
		this.setState({settingsShown: value});
	}

	getSetting(name) {
		return LocalStorage.getItem('seotools-' + name);
	}

	handleSettingsChange(name, value) {
		LocalStorage.setItem('seotools-' + name, value);
		let settingsObject = this.state.settings;
		settingsObject[name] = value;
		this.setState(settingsObject);
	}

	render() {
		const isPro = this.state.loggedIn && this.state.user.plan !== 'free';
		const settingsPopup = this.state.settingsShown ? (<div className="overlay"><Settings
			settings={this.state.settings}
			changeCallback={this.handleSettingsChange}
			closeCallback={this.toggleSettings}
			permissions={this.state.permissions}
			isPro={isPro}
		/></div>) : '';
		return (
			<div className="App">
				<Editor
					contentCallback={this.saveContent}
					urlCallback={this.saveUrl}
					content={this.state.content}
				/>
				<InfoBar
					content={this.state.content}
					appSettings={this.state.settings}
					isPro={isPro}
					score={this.state.score}
					toggleSettingsCallback={this.toggleSettings}
				/>
				<CheckList
					content={this.state.content}
					contentCallback={this.saveContent}
					appSettings={this.state.settings}
					isPro={isPro}
					scoreCallback={this.saveScore}
					language={this.state.settings.language}
					limits={this.state.limits}
					limitUsage={this.state.limitUsage}
					limitUsageCallback={this.updateLimitUsage}
					permissions={this.state.permissions}
					toggleSettingsCallback={this.toggleSettings}
				/>
				{settingsPopup}
			</div>
		);
	}

	updateLimitUsage(limitName) {
		const limits = [];
		const newState = {};
		let newLimitUsage = {
			daily: {},
			monthly: {},
		};
		if (this.state.limits.daily[limitName]) {
			limits.push('daily-' + limitName);
			newLimitUsage.daily[limitName] = this.state.limitUsage.daily[limitName] + 1;
		}
		if (this.state.limits.monthly[limitName]) {
			limits.push('monthly-' + limitName);
			newLimitUsage.monthly[limitName] = this.state.limitUsage.monthly[limitName] + 1;
		}
		newState.limitUsage = newLimitUsage;
		const formData = new FormData();
		formData.append('uid', this.state.user.id);
		formData.append('limits', JSON.stringify(limits));

		fetch('ajax/update-limit-usage.php', {
			method: 'POST',
			body: formData,
		});

		this.setState(newState);
	}
}

export default App;
